import React from 'react'
import { useSelector } from 'react-redux'

import { getNote } from 'data/notes/selectors'
import NoteIcon from 'components/Notes/Icon'

export default function DocTitleWithIcon({ id, fallback }) {
  const selector = React.useMemo(() => state => getNote(state, id), [id])
  const note = useSelector(selector)
  if (!note) {
    return fallback
  }

  return (
    <span className="flexbox flexbox-align-center margin-horizontal-smaller">
      <NoteIcon
        iconColor={note.iconColor}
        iconShape={note.iconShape}
        hasChildren={note.hasChildren}
        className="margin-right-smaller"
      />
      <span
        style={{ maxWidth: 168 }}
        className="ellipsis font-weight-bold shade-05"
      >
        {note.title}
      </span>
    </span>
  )
}
